import {
  DrawerContentComponentProps,
  DrawerContentScrollView,
  DrawerItem,
  DrawerItemList,
} from '@react-navigation/drawer';
import { Linking, View } from 'react-native';
import { Text } from '@/components/Text';

import { useAuth } from '../../hooks/useAuth';

import { useState } from 'react';
import { Divider } from 'react-native-elements';
import { Icon } from '../../components/Icon';
import colors from '../../config/colors';
import { Button } from '@/components/ui/therapist/Button';
import { Modal } from '@/components/ui/therapist/Modal';
import { Links } from '@/config/links';

type ExternalLinkItemProps = {
  href: string;
  text: string;
};
function ExternalLinkItem({ href, text }: ExternalLinkItemProps) {
  return (
    <DrawerItem
      label={(props) => (
        <View style={{ flexDirection: 'row', columnGap: 16 }}>
          <Text>{text}</Text>
          <Icon name="extLink" size={16} />
        </View>
      )}
      onPress={() => Linking.openURL(href)}
    />
  );
}

export function DrawerContent(props: DrawerContentComponentProps) {
  const { logout } = useAuth();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  function handlePressLogout() {
    setIsLogoutModalVisible(true);
  }

  return (
    <View style={{ flex: 1 }}>
      <DrawerContentScrollView {...props}>
        <View style={{ padding: 16 }}>
          <Text style={{ fontSize: 24, fontWeight: 'bold' }}>
            Einstellungen
          </Text>
        </View>
        <DrawerItemList {...props} />
        <Divider color={colors.lightGrey} width={2} />
        <View style={{ padding: 16 }}>
          <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Links</Text>
        </View>

        <ExternalLinkItem
          href={Links.anleitung.href}
          text={Links.anleitung.label}
        />
        <ExternalLinkItem
          href={Links.impressum.href}
          text={Links.impressum.label}
        />
        <ExternalLinkItem
          href={Links.datenschutz.href}
          text={Links.datenschutz.label}
        />

        <Divider color={colors.lightGrey} width={2} />
        <View style={{ padding: 16 }}>
          <Button
            label="Abmelden"
            look="danger"
            onPress={handlePressLogout}
            style={{ width: '100%', justifyContent: 'center' }}
          />
        </View>
      </DrawerContentScrollView>
      <Modal
        isVisible={isLogoutModalVisible}
        title="Abmelden"
        onClose={() => setIsLogoutModalVisible(false)}
        confirmActionButton={
          <Button
            label="Abmelden"
            look="danger"
            onPress={() => {
              logout();
              setIsLogoutModalVisible(false);
            }}
          />
        }
        cancelActionButton={
          <Button
            label="Abbrechen"
            look="secondary"
            onPress={() => setIsLogoutModalVisible(false)}
          />
        }
      >
        <Text style={{ fontSize: 20 }}>
          Möchten Sie sich wirklich abmelden?
        </Text>
      </Modal>
    </View>
  );
}
